import { getVersionForClone } from '../utils/clone'
import { baseTheme } from './baseTheme'
import { clone1Theme } from './clone1Theme'

export const theme = getVersionForClone<typeof baseTheme | typeof clone1Theme>({
	base: baseTheme,
	clone1: clone1Theme,
})
